export default __webpack_public_path__ + "static/media/EPK.46b2b8bd.pdf";